import { Text } from "slate";
const isElementWithReference = (candidate) => {
  return !Text.isText(candidate) && "referenceId" in candidate && !!candidate.referenceId;
};
export {
  isElementWithReference
};
//# sourceMappingURL=ElementWithReference.js.map
